var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "templatelayout"
    }
  }, [_vm.num_temp_display > -1 ? _c('popup', {
    attrs: {
      "opened": _vm.num_temp_display > -1
    },
    on: {
      "close": function ($event) {
        _vm.num_temp_display = -1;
        _vm.itemDisplayed = -1;
      }
    }
  }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_REACTIVER) && !_vm.evaluationInProgress ? _c('div', [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-pink-300",
      "bg-color-square": "bg-pink-100",
      "icon-color": "text-pink-600",
      "libelle": "Réactiver le modèle",
      "icon": "power"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.reactivate();
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [['multi2', 'ref_multi2'].includes(_vm.infosPage.type_ref) ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          " + _vm._s(_vm.templateVersions[_vm.num_temp_display][0].name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-10 place-content-center gap-4 h-16 lg:h-24 2xl:h-32"
  }, [_c('div', {
    staticClass: "ml-10 col-span-3"
  }, [_vm._v("\n            Intitulé\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n            Auto-évaluation\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n            Dernière éval.ref\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n            Nouvelle éval.ref\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 text-center"
  }, [_vm._v("\n            Comm.\n          ")])]), _vm._v(" "), _vm._l(_vm.templateVersions[_vm.num_temp_display][2].criterions, function (intitule, index) {
    return _c('div', {
      key: index,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 relative grid grid-cols-10 place-content-center gap-4 h-16 lg:h-24 2xl:h-32"
    }, [_c('div', {
      staticClass: "col-span-3 text-sm ml-10"
    }, [_vm._v("\n            " + _vm._s(intitule.description) + "\n          ")]), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-2",
      attrs: {
        "libelle": "",
        "name": index + 'auto_eval',
        "value": _vm.templateVersions[_vm.num_temp_display][1].criterions[Math.floor(Math.random() * Math.floor(_vm.templateVersions[_vm.num_temp_display][1].criterions.length))].value,
        "datas": _vm.templateVersions[_vm.num_temp_display][1].criterions
      }
    }), _vm._v(" "), _c('input-text', {
      staticClass: "lg:col-span-2",
      attrs: {
        "libelle": "",
        "name": index + 'derniere_eval',
        "disabled": "true",
        "value": _vm.templateVersions[_vm.num_temp_display][1].criterions[Math.floor(Math.random() * Math.floor(_vm.templateVersions[_vm.num_temp_display][1].criterions.length))].value
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-2",
      attrs: {
        "libelle": "",
        "name": index + 'nouvelle_eval',
        "necessary": true,
        "value": _vm.templateVersions[_vm.num_temp_display][1].criterions[Math.floor(Math.random() * Math.floor(_vm.templateVersions[_vm.num_temp_display][1].criterions.length))].value,
        "datas": _vm.templateVersions[_vm.num_temp_display][1].criterions
      }
    }), _vm._v(" "), _c('icon-comment', {
      staticClass: "col-span-1 place-self-center"
    })], 1);
  })], 2) : ['multi3', 'ref_multi3'].includes(_vm.infosPage.type_ref) ? _c('div', [_c('h3', {
    staticClass: "mb-10 w-full"
  }, [_vm._v("\n          " + _vm._s(_vm.templateVersions[_vm.num_temp_display][0].name) + "\n        ")]), _vm._v(" "), _vm._l(_vm.templateVersions[_vm.num_temp_display].length - 1, function (index) {
    return _c('div', {
      key: index,
      staticClass: "grid grid-cols-12 mb-15"
    }, [_c('div', {
      staticClass: "col-span-full uppercase text-base text-indigo-600 text-left"
    }, [_vm._v("\n            " + _vm._s(_vm.templateVersions[_vm.num_temp_display][index][0].libelle) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-4"
    }, _vm._l(_vm.templateVersions[_vm.num_temp_display][index], function (field, jndex) {
      return _c('div', {
        key: jndex,
        staticClass: "col-span-full",
        class: jndex == 0 ? 'display-none' : field.length > 2 ? 'lg:col-span-4' : 'lg:col-span-6'
      }, [jndex !== 0 && field.type == 'text' ? _c('input-text', {
        attrs: {
          "libelle": field.libelle
        }
      }) : _vm._e(), _vm._v(" "), jndex !== 0 && field.type == 'multi' ? _c('input-select', {
        attrs: {
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + index + jndex,
          "libelle": field.libelle,
          "datas": field.criterions
        }
      }) : _vm._e(), _vm._v(" "), field.type == 'text-area' ? _c('input-text-area', {
        attrs: {
          "size": "5",
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', ''),
          "libelle": field.libelle
        }
      }) : _vm._e()], 1);
    }), 0)]);
  })], 2) : ['pro', 'ref_pro'].includes(_vm.infosPage.type_ref) ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          " + _vm._s(_vm.templateVersions[_vm.num_temp_display][0].name) + "\n        ")]), _vm._v(" "), _vm.activities && _vm.activities.length > 0 ? _c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
  }, [_c('div', {
    staticClass: "col-start-2 col-span-3"
  }, [_vm._v("\n            Activité\n          ")]), _vm._v(" "), ((_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
    return temp.libelle === 'Niveau de maîtrise acquis';
  }) || [])[0] || {}).included ? _c('div', {
    staticClass: "col-span-4"
  }, [_vm._v("\n            Niveau de maîtrise\n          ")]) : _vm._e(), _vm._v(" "), ((_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
    return temp.libelle === 'Temps consacré';
  }) || [])[0] || {}).included ? _c('div', {
    staticClass: "col-span-4"
  }, [_vm._v("\n            Temps consacré\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l(_vm.activities, function (activity, num) {
    return _c('div', {
      key: num,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed == num
      },
      attrs: {
        "id": 'item' + num
      },
      on: {
        "click": function ($event) {
          return _vm.displayItem(num);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-1 text-pink-600 justify-self-center"
    }, [_c('icon', {
      staticClass: "transform transition-transform ease-in-out duration-300 mt-1.5",
      class: {
        'rotate-90': _vm.itemDisplayed == num
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 text-base font-normal"
    }, [_c('span', [_vm._v(_vm._s(activity.name))])]), _vm._v(" "), ((_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Niveau de maîtrise acquis';
    }) || [])[0] || {}).included ? _c('div', {
      staticClass: "col-span-4 text-base font-normal"
    }, [activity.lvl !== '' || activity.lvl !== undefined || activity.lvl !== null ? _c('span', [_vm._v("\n                " + _vm._s(activity.lvl) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Temps consacré';
    }) || [])[0] || {}).included ? _c('div', {
      staticClass: "col-span-4 text-base italic font-normal"
    }, [activity.time !== '' || activity.time !== undefined || activity.time !== null ? _c('span', [_vm._v("\n                " + _vm._s(activity.time) + "\n              ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm.itemDisplayed == num ? _c('div', {
      staticClass: "bg-white p-5 md:p-15 md:pb-0"
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 mb-15"
    }, [_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Temps consacré';
    })[0].included ? _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Temps consacré';
        })[0].libelle + num,
        "libelle": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Temps consacré';
        })[0].libelle,
        "value": activity.time,
        "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Temps consacré';
        })[0].criterions
      }
    }) : _vm._e(), _vm._v(" "), _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Niveau de maîtrise requis';
    })[0].included ? _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise requis';
        })[0].libelle + num,
        "libelle": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise requis';
        })[0].libelle,
        "value": activity.lvl,
        "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise requis';
        })[0].criterions
      }
    }) : _vm._e(), _vm._v(" "), _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Niveau de maîtrise acquis';
    })[0].included ? _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise acquis';
        })[0].libelle + num,
        "libelle": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise acquis';
        })[0].libelle,
        "value": activity.requis,
        "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Niveau de maîtrise acquis';
        })[0].criterions
      }
    }) : _vm._e(), _vm._v(" "), _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle === 'Perspectives d\'évolution';
    })[0].included ? _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Perspectives d\'évolution';
        })[0].libelle + num,
        "libelle": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Perspectives d\'évolution';
        })[0].libelle,
        "value": activity.evo,
        "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Perspectives d\'évolution';
        })[0].criterions
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
    }, [_c('div', {
      staticClass: "col-span-full uppercase text-indigo-600 text-base"
    }, [_vm._v("\n                Tâches Principales\n              ")]), _vm._v(" "), activity.tasks && activity.tasks.length > 0 ? _c('div', {
      staticClass: "col-span-full"
    }, [_c('div', {
      staticClass: "text-lg text-gray-600 grid grid-cols-10 gap-x-4"
    }, [_c('div', {
      staticClass: "col-span-3 ml-10"
    }, [_vm._v("\n                    Tâche\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Auto-évaluation\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Dernière eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Nouvelle eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 text-center"
    }, [_vm._v("\n                    Comm.\n                  ")])]), _vm._v(" "), _vm._l(activity.tasks, function (task, index) {
      return _c('div', {
        key: index,
        staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
      }, [_c('div', {
        staticClass: "col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
      }, [_vm._v("\n                      " + _vm._s(task.name) + "\n                    ")]), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-select', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "name": index + num + 'tasks',
          "value": task.auto,
          "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions
        }
      }), _vm._v(" "), _c('icon-comment', {
        staticClass: "lg:col-span-1 cursor-pointer lg:place-self-center",
        attrs: {
          "name": 'comment-' + num + '-' + task.name + '-' + index
        }
      })], 1)]);
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
    }, [_c('div', {
      staticClass: "col-span-full uppercase text-indigo-600 text-base"
    }, [_vm._v("\n                Pratiques Professionnelles\n              ")]), _vm._v(" "), activity.pratiques_pro && activity.pratiques_pro.length > 0 ? _c('div', {
      staticClass: "col-span-full"
    }, [_c('div', {
      staticClass: "text-lg text-gray-600 grid grid-cols-10 gap-x-4"
    }, [_c('div', {
      staticClass: "col-span-3 ml-10"
    }, [_vm._v("\n                    Comportement\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Auto-évaluation\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Dernière eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Nouvelle eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 text-center"
    }, [_vm._v("\n                    Comm.\n                  ")])]), _vm._v(" "), _vm._l(activity.pratiques_pro, function (pra, index) {
      return _c('div', {
        key: index,
        staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
      }, [_c('div', {
        staticClass: "col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
      }, [_vm._v("\n                      " + _vm._s(pra.name) + "\n                    ")]), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-select', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "name": index + num + 'pra',
          "value": pra.auto,
          "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions
        }
      }), _vm._v(" "), _c('icon-comment', {
        staticClass: "lg:col-span-1 cursor-pointer lg:place-self-center",
        attrs: {
          "name": 'comment-' + num + '-' + pra.name + '-' + index
        }
      })], 1)]);
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
    }, [_c('div', {
      staticClass: "col-span-full uppercase text-indigo-600 text-base"
    }, [_vm._v("\n                Connaissances associées\n              ")]), _vm._v(" "), activity.activity_connaissances && activity.activity_connaissances.length > 0 ? _c('div', {
      staticClass: "col-span-full"
    }, [_c('div', {
      staticClass: "text-lg text-gray-600 grid grid-cols-10 gap-x-4"
    }, [_c('div', {
      staticClass: "col-span-3 ml-10"
    }, [_vm._v("\n                    Connaissance\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Auto-évaluation\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Dernière eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Nouvelle eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 text-center"
    }, [_vm._v("\n                    Comm.\n                  ")])]), _vm._v(" "), _vm._l(activity.activity_connaissances, function (con, index) {
      return _c('div', {
        key: index,
        staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
      }, [_c('div', {
        staticClass: "col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
      }, [_vm._v("\n                      " + _vm._s(con.name) + "\n                    ")]), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-select', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "name": index + num + 'con',
          "value": con.auto,
          "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions
        }
      }), _vm._v(" "), _c('icon-comment', {
        staticClass: "lg:col-span-1 cursor-pointer lg:place-self-center",
        attrs: {
          "name": 'comment-' + num + '-' + con.name + '-' + index
        }
      })], 1)]);
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
    }, [_c('div', {
      staticClass: "col-span-full uppercase text-indigo-600 text-base"
    }, [_vm._v("\n                Comportement / Attitudes\n              ")]), _vm._v(" "), activity.activity_comportement && activity.activity_comportement.length > 0 ? _c('div', {
      staticClass: "col-span-full"
    }, [_c('div', {
      staticClass: "text-lg text-gray-600 grid grid-cols-10 gap-x-4"
    }, [_c('div', {
      staticClass: "col-span-3 ml-10"
    }, [_vm._v("\n                    Pratique\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Auto-évaluation\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Dernière eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 text-center"
    }, [_vm._v("\n                    Nouvelle eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 text-center"
    }, [_vm._v("\n                    Comm.\n                  ")])]), _vm._v(" "), _vm._l(activity.activity_comportement, function (com, index) {
      return _c('div', {
        key: index,
        staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
      }, [_c('div', {
        staticClass: "h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
      }, [_c('div', {
        staticClass: "col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
      }, [_vm._v("\n                      " + _vm._s(com.name) + "\n                    ")]), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-text', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "value": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions[Math.floor(Math.random() * _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions.length)].value,
          "disabled": "true"
        }
      }), _vm._v(" "), _c('input-select', {
        staticClass: "lg:col-span-2",
        attrs: {
          "libelle": "",
          "name": index + num + 'com',
          "value": com.auto,
          "datas": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
            return temp.libelle === 'Critères d\'évaluation';
          })[0].criterions
        }
      }), _vm._v(" "), _c('icon-comment', {
        staticClass: "lg:col-span-1 cursor-pointer lg:place-self-center",
        attrs: {
          "name": 'comment-' + num + '-' + com.name + '-' + index
        }
      })], 1)]);
    })], 2) : _vm._e()])]) : _vm._e()]);
  })], 2) : ['sco', 'ref_sco'].includes(_vm.infosPage.type_ref) ? _c('div', [_c('h3', {
    staticClass: "mt-15 mb-15 w-full"
  }, [_vm._v("\n          " + _vm._s(_vm.infosPage.libelle_template) + "\n        ")]), _vm._v(" "), _vm.modules && _vm.modules.length > 0 ? _c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
  }, [_c('div', {
    staticClass: "col-start-2 col-span-7"
  }, [_vm._v("\n            Module\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4"
  }, [_vm._v("\n            Temps consacré\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.modules, function (mod, num) {
    return _c('div', {
      key: num,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed == num
      },
      attrs: {
        "id": 'item' + num
      },
      on: {
        "click": function ($event) {
          return _vm.displayItem(num);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-1 text-pink-600 justify-self-center flex flex-col justify-around"
    }, [_c('icon', {
      staticClass: "transform transition-transform ease-in-out duration-300",
      class: {
        'rotate-90': _vm.itemDisplayed == num
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-7 text-base font-normal"
    }, [_c('span', [_vm._v(_vm._s(mod.display_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4 text-base font-normal"
    }, [mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    }).length > 0 && (mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== '' || mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== undefined || mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== null || mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== []) ? _c('span', [_vm._v("\n                " + _vm._s(mod.general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_vm.itemDisplayed == num ? _c('div', {
      staticClass: "bg-white my-5 lg:my-10 px-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 mb-15"
    }, _vm._l(_vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
      return temp.libelle && !['Critères d\'évaluation', 'Critères'].includes(temp.libelle);
    }), function (gen, index) {
      return _c('div', {
        key: index,
        staticClass: "col-span-6"
      }, [_c('input-select', {
        attrs: {
          "name": gen.libelle.replace('\'', ''),
          "libelle": gen.libelle,
          "value": mod.general[index].value,
          "datas": gen.criterions
        },
        on: {
          "input": function (newValue) {
            _vm.$set(mod.general[index], 'value', newValue);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('module-category', {
      attrs: {
        "datas": mod.module_competences,
        "form": mod.module_competences,
        "list-criterions": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Critères d\'évaluation';
        })[0].criterions,
        "name": "module_competences",
        "id-pass": _vm.user.id,
        "id-user": _vm.user.id,
        "hidden-fields": _vm.hiddenFields,
        "num": num,
        "latest-eval": [],
        "preview-mode": true
      },
      on: {
        "hideField": function (field) {
          _vm.hiddenFields[field] = !_vm.hiddenFields[field];
        }
      }
    }), _vm._v(" "), _c('module-category', {
      attrs: {
        "datas": mod.module_competences_transversales,
        "form": mod.module_competences_transversales,
        "list-criterions": _vm.templateVersions[_vm.num_temp_display].filter(function (temp) {
          return temp.libelle === 'Critères d\'évaluation';
        })[0].criterions,
        "name": "module_competences_transversales",
        "id-pass": _vm.user.id,
        "id-user": _vm.user.id,
        "hidden-fields": _vm.hiddenFields,
        "num": num,
        "latest-eval": [],
        "preview-mode": true
      },
      on: {
        "hideField": function (field) {
          _vm.hiddenFields[field] = !_vm.hiddenFields[field];
        }
      }
    })], 1) : _vm._e()])], 1);
  })], 2) : ['multi1', 'ref_multi1'].includes(_vm.infosPage.type_ref) ? _c('div', [_c('h3', {
    staticClass: "mb-10 w-full"
  }, [_vm._v("\n          " + _vm._s(_vm.templateVersions[_vm.num_temp_display][0].name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, _vm._l(_vm.templateVersions[_vm.num_temp_display], function (field, jndex) {
    return _c('div', {
      key: jndex,
      staticClass: "col-span-full lg:col-span-3 flex",
      class: {
        'lg:col-start-1': jndex == 1,
        'lg:col-span-4': jndex == 0
      }
    }, [jndex == 0 ? _c('div', {
      staticClass: "pt-8 mr-4 cursor-pointer"
    }, [_c('span', {
      staticClass: "minus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
    }, [_c('icon', {
      attrs: {
        "name": "close"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), field.type == 'text' && jndex == 0 ? _c('input-text', {
      attrs: {
        "libelle": field.libelle
      }
    }) : field.type == 'text' && jndex > 0 ? _c('input-text', {
      attrs: {
        "libelle": field.libelle
      }
    }) : field.type == 'multi' ? _c('input-select', {
      attrs: {
        "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + jndex,
        "libelle": field.libelle,
        "datas": field.criterions
      }
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('module-header', {
    attrs: {
      "module-name": "Modèles de pages",
      "illustration-name": "templates"
    },
    scopedSlots: _vm._u([{
      key: "ariane-wire",
      fn: function () {
        return [_c('div', {
          staticClass: "inline-flex flex-col xxl:flex-row flex-wrap w-8/12"
        }, [_c('div', {
          staticClass: "text-indigo-600 inline-flex font-light"
        }, [_c('icon', {
          attrs: {
            "name": "file-add"
          }
        }), _vm._v(" "), _c('div', [_vm._v(" Modèles de pages ")]), _vm._v(" "), _c('span', {
          staticClass: "hidden xxl:inline-block"
        }, [_vm._v("> ")])], 1), _vm._v(" "), _c('span', {
          staticClass: "text-pink-600 font-light"
        }, [_vm._v(_vm._s(_vm.infosPage.libelle_module) + "\n          "), _c('span', {
          staticClass: "hidden xxl:inline-block"
        }, [_vm._v("> ")])]), _vm._v(" "), _c('span', {
          staticClass: "text-gray-600 font-light"
        }, [_vm._v(_vm._s(_vm.infosPage.libelle_template))])])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm.allowed ? _c('div', [_c('div', {
    staticClass: "relative flex flex-col align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 min-h-halfscreen"
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    },
    on: {
      "cancel": function ($event) {
        return _vm.cancel_nosave();
      },
      "quit": function ($event) {
        return _vm.quit_nosave();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-9/10 md:top-0 z-10"
  }, [_c('save-button', {
    staticClass: "right-1/2 transform translate-x-1/2 md:right-15 md:translate-x-0 md:top-10",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": function ($event) {
        return _vm.save_datas(_vm.$refs.template.template);
      }
    }
  })], 1), _vm._v(" "), _c('router-view', {
    ref: "template"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-16"
  }, [_c('div', {
    staticClass: "-my-2 py-2"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table"
  }, [_c('h3', {
    staticClass: "mt-10 mb-10 w-full"
  }, [_vm._v("\n            Historique du modèle de page\n          ")]), _vm._v(" "), _vm.templateVersions.length > 0 ? _c('list-grid', {
    attrs: {
      "list-items": _vm.templateVersions
    },
    on: {
      "displayNum": _vm.displayHistory
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-5 md:ml-0 col-start-1 md:col-start-2 col-span-3"
        }, [_vm._v("\n                Nom modèle\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2hidden md:inline"
        }, [_vm._v("\n                1ère évaluation\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2hidden md:inline"
        }, [_vm._v("\n                Dernière évaluation\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:hidden"
        }, [_vm._v("\n                Evaluations\n              ")]), _vm._v(" "), ['multi2', 'ref_multi2'].includes(_vm.infosPage.type_ref) ? _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Nb. intitulé(s)\n              ")]) : _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Nb. champ(s)\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Nb. évaluation(s)\n              ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var template = _ref.item,
          num_temp = _ref.num;
        return [['multi2', 'ref_multi2'].includes(_vm.infosPage.type_ref) ? [_c('div', {
          staticClass: "col-span-1 hidden md:flex place-self-center text-pink-600 justify-center"
        }, [_c('icon', {
          attrs: {
            "name": "eye"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "ml-5 md:ml-0 col-span-3 text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(template[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].first_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].last_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:hidden text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].first_eval).toLocaleDateString()) + " - " + _vm._s(new Date(template[0].last_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 text-base place-self-center"
        }, [_vm._v("\n                  " + _vm._s(template[2].criterions.length - 1) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 text-base place-self-center"
        }, [_vm._v("\n                  " + _vm._s(template[0].nb_eval) + "\n                ")])] : [_c('div', {
          staticClass: "ml-5 md:ml-0 col-span-1 place-self-center text-pink-600 hidden md:flex justify-center"
        }, [_c('icon', {
          attrs: {
            "name": "eye"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(template[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].first_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden md:inline text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].last_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:hidden text-base place-self-center justify-self-start"
        }, [_vm._v("\n                  " + _vm._s(new Date(template[0].first_eval).toLocaleDateString()) + " - " + _vm._s(new Date(template[0].last_eval).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 text-base place-self-center"
        }, [_vm._v("\n                  " + _vm._s(template.length - 1) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 text-base place-self-center"
        }, [_vm._v("\n                  " + _vm._s(template[0].nb_eval) + "\n                ")])]];
      }
    }], null, false, 395422319)
  }) : _c('div', [_c('h6', {
    staticClass: "text-indigo-600 mb-12"
  }, [_vm._v("\n              Il n'y a pas encore de modèle de page historisé.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1)])])]) : _c('page-not-allowed')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }